import * as actionTypes from '../actions/actionTypes';
import { CartModel } from '@model/CartModel';
import { EnabledShippingModes } from '@model/EnabledShippingModes';
import { updateObject } from '@utils/utils';

class InitialStateProps {
    cart: CartModel = null;
    isLoading: false;
    isLoaded: false;
    config = null;
    enabledShippingModes: EnabledShippingModes[] = [];
    isLoadingEnabledShippingModes: false;
    isLoadednabledShippingModes: false;
    formattedOrderItems: [];
    selectedShippingMode: EnabledShippingModes;
    shippingAmout: 0;
    address = null;
    isAddressLoaded = null;
    isMobile = false;
    openModal = false;
    order = null;
    orderId = null;
    email = null;
    faq = null;
    showSessionModal = false;
    allBillingAddresses: [];
    showGenericErrorModal = false;
    showPromoCodeFeedback = false;
    modalErrorText = '';
    person = null;
    insurance = undefined;
    espotTyp = null;
    disableNavigation = 0;
    insuranceError = false;
    espotFooter = null;
    clientSideNavigation = false;
    isEmptyCart = false;
    openModalBoss = false;
    physicalStores = null;
    radius = '50';
    selectedStore = null;
    mapLink = null;
    isBossSelected = false;
    latitude = null;
    longitude = null;
    errorBoss = false;
    speedyOrderDetails = null;
}

const initialState: InitialStateProps =  new InitialStateProps();

const reducer = (state = initialState, action): InitialStateProps => {
    switch(action.type) {
        case actionTypes.GET_CART_REQUEST: 
            return getCartRequest(state);
        case actionTypes.GET_CART_SUCCESS:
            return getCartSuccess(state, action);
        case actionTypes.GET_CART_FAILURE:
            return getCartFailure(state);
        case actionTypes.SAVE_CONFIG:
            return saveConfig(state, action);
        case actionTypes.GET_ENABLED_SHIPPING_MODES_REQUEST:
            return getEnabledShippinModesRequest(state);
        case actionTypes.GET_ENABLED_SHIPPING_MODES_SUCCESS:
            return getEnabledShippingModesSuccess(state, action);
        case actionTypes.GET_ENABLED_SHIPPING_MODES_FAILURE:
            return getEnabledShippingModesFailure(state);
        case actionTypes.SET_FORMATTED_ORDER_ITEMS:
            return setFormattedOrderItems(state, action);
        case actionTypes.SET_SELECTED_SHIPPING_MODE:
            return setSelectedShippingMode(state, action);
        case actionTypes.GET_ADDRESS_SUCCESS:
            return getAddressSuccess(state, action);
        case actionTypes.GET_ADDRESS_FAILURE:
            return getAddressFailure(state);
        case actionTypes.SET_ADDRESS:
            return setAddress(state, action)
        case actionTypes.SET_IS_MOBILE:
            return setIsMobile(state, action);
        case actionTypes.OPEN_MODAL:
            return setModal(state, action);
        case actionTypes.START_LOADING:
            return startLoading(state);
        case actionTypes.END_LOADING:
            return endLoading(state);
        case actionTypes.ERROR_LOADING:
            return errorLoading(state);
        case actionTypes.SET_FAQ_SUCCESS:
            return setFaqSuccess(state, action);
        case actionTypes.SET_FAQ_FAILURE:
            return setFaqFailure(state);
        case actionTypes.SET_CART_UPSELL_DETAILS_SUCCESS:
            return setUpsellDetailsSuccess(state, action);
        case actionTypes.SET_CART_UPSELL_DETAILS_FAILURE:
            return setUpsellDetailsFailure(state);
        case actionTypes.SET_ORDER_ID:
            return setOrderId(state, action);
        case actionTypes.SET_SHOW_SESSION_MODAL:
            return setShowSessionModal(state, action);
        case actionTypes.GET_ALL_BILLING_ADDRESSES:
            return getAllBillingAddresses(state, action);
        case actionTypes.SET_EMAIL:
            return setEmail(state, action);
        case actionTypes.SET_SHOW_GENERIC_ERROR_MODAL:
            return setGenericErrorModal(state, action);
        case actionTypes.SET_SHOW_PROMO_CODE_FEEDBACK:
            return setShowPromoCodeFeedback(state, action);
        case actionTypes.SET_PERSON:
            return setPerson(state, action);
        case actionTypes.SET_INSURANCE:
            return setInsurance(state, action);
        case actionTypes.GET_ESPOT_TYP_SUCCESS:
            return getEspotTypSuccess(state, action);
        case actionTypes.GET_ESPOT_TYP_FAILURE:
            return getEspotTypFailure(state);
        case actionTypes.SET_DISABLE_NAVIGATION:
            return setDisableNavigation(state, action);
        case actionTypes.SET_INSURANCE_ERROR:
            return setInsuranceError(state, action);
        case actionTypes.GET_ESPOT_FOOTER_SUCCESS:
            return getEspotFooterSuccess(state, action);
        case actionTypes.GET_ESPOT_FOOTER_FAILURE:
            return getEspotFooterFailure(state);
        case actionTypes.SET_CLIENT_SIDE_NAVIGATION:
            return setClientSideNavigation(state, action);
        case actionTypes.OPEN_MODAL_BOSS:
            return setOpenModalBoss(state, action);
          case actionTypes.PHYSICAL_STORES:
            return setPhysicalStores(state, action);
          case actionTypes.RADIUS:
            return setRadius(state, action);
          case actionTypes.SELECTED_STORE:
            return setSelectedStore(state, action);
          case actionTypes.CLICKED_STORE:
            return setClickedStore(state, action);
          case actionTypes.IS_BOSS_SELECTED:
            return setIsBossSelected(state, action);
          case actionTypes.LATITUDE:
            return setLatitude(state, action);
          case actionTypes.LONGITUDE:
            return setLongitude(state, action);
          case actionTypes.ERROR_BOSS:
            return setErrorBoss(state, action);
          case actionTypes.SET_SPEEDY_ORDER_DETAILS:
            return setSpeedyOrderDetails(state, action);
        default: 
            return state;
    }
}

export default reducer;

/* LOADING */
const startLoading = (state) => {
    return updateObject(state, {
        isLoading: true,
        isLoaded: false
    })
}

const endLoading = (state) => {
    return updateObject(state, {
        isLoading: false,
        isLoaded: true
    });
}

const errorLoading = (state) => {
    return updateObject(state, {
        isLoading: false,
        isLoaded: false
    })
}

/* CART */
const getCartRequest = (state) => {
    return updateObject(state, {
        isLoadingCart: true,
        isLoadedCart: false
    })
}

const getCartSuccess = (state, action) => {
    return updateObject(state, {
        cart: action.cart,
        isLoadedCart: true,
        isEmptyCart: false
    })
}

const getCartFailure = (state) => {
    return updateObject(state, {
        isLoadingCart: false,
        isLoadedCart: false,
        isEmptyCart: true,
    })
}

/* ENABLED SHIPPING METHODS */
const getEnabledShippinModesRequest = (state) => {
    return updateObject(state, {
        isLoadingEnabledShippingModes: true
    });
}

const getEnabledShippingModesSuccess = (state, action) => {
    return updateObject(state, {
        enabledShippingModes: action.data.usableShippingMode,
        isLoadingEnabledShippingModes: false,
        isLoadedEnabledShippingModes: true
    })
}

const getEnabledShippingModesFailure = (state) => {
    return updateObject(state, {
        isLoadingEnabledShippingModes: false,
        isLoadedEnabledShippingModes: false
    })
}

const setSelectedShippingMode = (state, action) => {
    return updateObject(state, {
        selectedShippingMode: action.selectedShippingMode
    })
}

/* CONFIG */
const saveConfig = (state, action) => {
    return updateObject(state, {
        config: action.config
    })
}

const setModal = (state, action) => {
    return updateObject(state, {
        openModal: action.openModal
    })
}

/* ORDER ITEMS */
const setFormattedOrderItems = (state, action) => {
    return updateObject(state, {
        formattedOrderItems: action.items,
    })
}

/* CUSTOMER */
const getAddressSuccess = (state, action) => {
    return updateObject(state, {
        address: action.address,
        isAddressLoaded: true
    })
}

const getAddressFailure = (state) => {
    return updateObject(state, {
        isAddressLoaded: false
    })
}

const setAddress = (state, action) => {
    return updateObject(state, {
        address: action.address
    })
}

const getAllBillingAddresses = (state, action) => {
    return updateObject(state, {
        allBillingAddresses: action.allBillingAddresses
    })
}

const setEmail = (state, action) => {
    return updateObject(state, {
        email: action.email
    })
}

const setIsMobile = (state, action) => {
    return updateObject(state, {
        isMobile: action.isMobile
    })
}

/* FAQ */
const setFaqSuccess = (state, action) => {
    return updateObject(state, {
        faq: action.faq
    })
}

const setFaqFailure = (state) => {
    return updateObject(state, {
        isLoading: false,
        isLoaded: false
    })
}

/* CART_UPSELL_DETAILS */
const setUpsellDetailsSuccess = (state, action) => {
    return updateObject(state, {
        upsellDetails: action.upsellDetails
    })
}

const setUpsellDetailsFailure = (state) => {
    return updateObject(state, {
        isLoading: false,
        isLoaded: false
    })
}

/* ORDER */
const setOrderId = (state, action) => {
    return updateObject(state, {
        orderId: action.orderId
    })
}

/* SESSION */
const setShowSessionModal = (state, action) => {
    return updateObject(state, {
        showSessionModal: action.showSessionModal
    })
}

const setGenericErrorModal = (state, action) => {
    return updateObject(state, {
        showGenericErrorModal: action.showGenericErrorModal,
        modalErrorText: action.modalErrorText
    })
}

const setShowPromoCodeFeedback = (state, action) => {
    return updateObject(state,  {
        showPromoCodeFeedback: action.showPromoCodeFeedback
    })
}

const setPerson = (state, action) => {
    return updateObject(state, {
        person: action.person
    })
}

const setInsurance = (state, action) => {
    return updateObject(state, {
        insurance: action.insurance
    })
}

/* ESPOT TYP */
const getEspotTypSuccess = (state, action) => {
    return updateObject(state, {
        espotTyp: action.espotTyp
    })
}

const getEspotTypFailure = (state) => {
    return updateObject(state, {
        espotTyp: null
    })
}

const setDisableNavigation = (state, action) => {
    return updateObject(state, {
        disableNavigation: state.disableNavigation + action.disableNavigation
    })
}

const setInsuranceError = (state, action) => {
    return updateObject(state, {
        insuranceError: action.insuranceError
    })
}

/* FOOTER TYP */
const getEspotFooterSuccess = (state, action) => {
    return updateObject(state, {
        espotFooter: action.espotFooter
    })
}

const getEspotFooterFailure = (state) => {
    return updateObject(state, {
        espotFooter: null
    })
}

const setClientSideNavigation = (state, action) => {
    return updateObject(state, {
        clientSideNavigation: action.clientSideNavigation
    })
}

/* BOSS */
const setOpenModalBoss = (state, action) => {
    return updateObject(state, {
      openModalBoss: action.openModalBoss,
      physicalStores: null,
    });
  };
  
  const setPhysicalStores = (state, action) => {
    return updateObject(state, {
      physicalStores: action.physicalStores,
      selectedStore: action.physicalStores[0],
      mapLink: action.physicalStores[0].x_staticMapImage,
    });
  };
  
  const setRadius = (state, action) => {
    return updateObject(state, {
      radius: action.radius,
    });
  };
  
  const setSelectedStore = (state, action) => {
    return updateObject(state, {
      selectedStore: action.selectedStore,
      mapLink: !!action.selectedStore ? action.selectedStore.x_staticMapImage : null,
    });
  };
  
  const setClickedStore = (state, action) => {
    return updateObject(state, {
      clickedStore: action.clickedStore,
    });
  };
  
  const setIsBossSelected = (state, action) => {
    return updateObject(state, {
      isBossSelected: action.isBossSelected,
    });
  };
  
  const setLatitude = (state, action) => {
    return updateObject(state, {
      latitude: action.latitude,
    });
  };
  
  const setLongitude = (state, action) => {
    return updateObject(state, {
      longitude: action.longitude,
    });
  };
  
  const setErrorBoss = (state, action) => {
    return updateObject(state, {
      errorBoss: action.errorBoss,
    });
  };

  const setSpeedyOrderDetails = (state, action) => {
    return updateObject(state, {
        speedyOrderDetails: action.speedyOrderDetails
    })
  }